import { useMemo, type ReactNode } from "react";

import { usePreferences } from "@/core/state/preferences";

import { LocaleContext, type LocaleContextValue } from "./context";
import { catalogs, translate } from "./lookup";

export function LocaleProvider({ children }: { children: ReactNode }) {
  const locale = usePreferences((state) => state.locale);
  const value = useMemo<LocaleContextValue>(() => ({
    locale,
    catalog: catalogs[locale] ?? catalogs["zh-CN"],
    t: (key) => translate(locale, key),
  }), [locale]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
